import { getAccessTokenFromCookie } from "../util/authentication";
import {
  BID_AWARD_SERVICE_API_RUN_SHIFT_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_FREEDAY_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_IAM_FTO_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_TWU_DAT_FTO_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_IAM_DAT_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_NC_PTO_FTO_BID_AWARD,
  BID_AWARD_SERVICE_API_RUN_NC_PTO_GOC_HOL_BID_AWARD,
} from "../util/constants";

export const runShiftBidAward = async (referenceNumber, eidList = null) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API + BID_AWARD_SERVICE_API_RUN_SHIFT_BID_AWARD + "/" + referenceNumber;

  if (eidList) {
    apiEndpoint += "/" + eidList;
  }

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runFreedayBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API + BID_AWARD_SERVICE_API_RUN_FREEDAY_BID_AWARD + "/" + referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runIAMFTOBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API + BID_AWARD_SERVICE_API_RUN_IAM_FTO_BID_AWARD + "/" + referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runTWUDATFTOBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API +
    BID_AWARD_SERVICE_API_RUN_TWU_DAT_FTO_BID_AWARD +
    "/" +
    referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runIAMDATBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API + BID_AWARD_SERVICE_API_RUN_IAM_DAT_BID_AWARD + "/" + referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runNCPTOFTOBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API +
    BID_AWARD_SERVICE_API_RUN_NC_PTO_FTO_BID_AWARD +
    "/" +
    referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const runNCGOCHOLBidAward = async (referenceNumber) => {
  let apiEndpoint =
    process.env.REACT_APP_BID_AWARD_SERVICE_API +
    BID_AWARD_SERVICE_API_RUN_NC_PTO_GOC_HOL_BID_AWARD +
    "/" +
    referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};
